import { useEffect, useMemo, useRef } from 'react';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';
import { useAppStore } from '@/state/store';

export function BatMesh() {
  const geometry = useAppStore((s) => s.geometry);
  const model = useAppStore((s) => s.model);
  const wireframe = useAppStore((s) => s.viewer.wireframe);
  const sectionClipping = useAppStore((s) => s.viewer.sectionClipping);
  const clipPosition = useAppStore((s) => s.viewer.clipPosition);
  const setMeshRef = useAppStore((s) => s.setMeshRef);

  const meshRef = useRef<THREE.Mesh>(null);
  const { gl } = useThree();

  useEffect(() => {
    gl.localClippingEnabled = true;
  }, [gl]);

  useEffect(() => {
    setMeshRef(meshRef.current);
    return () => setMeshRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geometry]);

  const clippingPlanes = useMemo(() => {
    if (!sectionClipping || !geometry) return [];
    geometry.computeBoundingBox();
    const box = geometry.boundingBox!;
    const planeX = THREE.MathUtils.lerp(box.min.x, box.max.x, clipPosition);
    return [new THREE.Plane(new THREE.Vector3(-1, 0, 0), planeX)];
  }, [sectionClipping, clipPosition, geometry]);

  if (!geometry) return null;

  return (
    <mesh
      ref={meshRef}
      geometry={geometry}
      castShadow
      receiveShadow
      name={model?.modelName ?? 'MarkLumberBat'}
    >
      <meshStandardMaterial
        color="#c9a06a"
        roughness={0.68}
        metalness={0.04}
        wireframe={wireframe}
        clippingPlanes={clippingPlanes}
        clipShadows
        side={THREE.DoubleSide}
      />
    </mesh>
  );
}
